/**
 * @description 消息模版列表表格列头配置
 * @returns {Array} 表格列配置数组
 */
export default function () {
  /* 表格列头配置 */
  return [
    // 序号列
    { label: "序号", type: "index", width: 80 },
    
    // 模版ID
    { label: "模版ID", prop: "id", width: 100 },
    
    // 模版名称
    { label: "模版名称", prop: "template_name", minWidth: 150 },
    
    // 所属公众号
    { label: "所属公众号", prop: "account_name", width: 150, slots: "account_name" },
    
    // 模版CODE
    { label: "模版CODE", prop: "template_code", minWidth: 200, slots: "template_code" },
    
    // 创建时间
    {
      label: "创建时间",
      prop: "create_time",
      width: 180
    },
    
    // 操作列
    {
      label: "操作",
      prop: "operation",
      width: 180,
      slots: "operation",
      fixed: "right"
    }
  ];
}
